import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../common/alert.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    private route: Router;
    private zone: NgZone;
    private alertService: AlertService;
    constructor(injector: Injector) {
        setTimeout(() => {
            this.route = injector.get(Router);
            this.zone = injector.get(NgZone);
            this.alertService = injector.get(AlertService);
        });
    }
    handleError(error: any) {
        this.zone.run(() => {
            if (error.status === 404) {
                this.route.navigate(['/pagenotfound']);
            }
            else if (error.status === 401) {
                this.route.navigate(['/unauthorize']);
            }
            else if (error.status === 408 || error.status === 406) {
                this.route.navigate(['/sessionexpired']);
            }
            else if (error.status <= 0) {
                this.route.navigate(['/badrequest']);
            }
            else {
                this.alertService.notify('error', 'Server Error', 'Some error has occured - '+ error.message);
                console.log(error);
            }
        });
    }
}
